import {
    ABSENCES_SAGA_EXPORT_CSV,
    ABSENCES_SAGA_GET_ABSENCES,
    ABSENCES_SAGA_GET_ABSENCES_IN_DATE_RANGE,
    ABSENCES_SAGA_GET_LEAVE_OF_ABSENCE_REQUESTS,
    ABSENCES_SAGA_REPLACE_USER_IN_SHIFT,
    ABSENCES_SAGA_SYNC_LEAVE_OF_ABSENCES_TO_LOKET,
} from '../actionTypes';

export const getLeaveOfAbsenceRequests = (page: string, status: string) => ({
    type: ABSENCES_SAGA_GET_LEAVE_OF_ABSENCE_REQUESTS, status, page,
});

export const getAbsences = () => ({ type: ABSENCES_SAGA_GET_ABSENCES });
export const getAbsencesInDateRange = () => ({ type: ABSENCES_SAGA_GET_ABSENCES_IN_DATE_RANGE });

export const replaceUserInShift = (addUserId: string, delUserId: string, shiftId: string) => ({
    type: ABSENCES_SAGA_REPLACE_USER_IN_SHIFT, addUserId, delUserId, shiftId,
});

export const exportCSV = () => ({ type: ABSENCES_SAGA_EXPORT_CSV });

export const syncAbsencesToLoket = (startDate: string, endDate: string | null) => ({
    type: ABSENCES_SAGA_SYNC_LEAVE_OF_ABSENCES_TO_LOKET, startDate, endDate,
});
